export default __webpack_public_path__ + "static/media/99HuntersLogo.81fcf2d6.svg";